const dematRegex = /^[0-9A-Z]{16}$/;

const onlyAlphabets = /^[a-zA-Z\s]*$/;

const panRegexPattern = /^[A-Za-z]{5}\d{4}[A-Za-z]{1}$/;

const isinRegexPattern = /^([A-Z]{2})([A-Z0-9]{9})([0-9]{1})$/;

const validPanRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

export { dematRegex, onlyAlphabets, panRegexPattern, isinRegexPattern, validPanRegex };
